import { render, staticRenderFns } from "./BookingImballi.vue?vue&type=template&id=62352e5b&scoped=true&"
import script from "./BookingImballi.vue?vue&type=script&lang=js&"
export * from "./BookingImballi.vue?vue&type=script&lang=js&"
import style0 from "./BookingImballi.vue?vue&type=style&index=0&id=62352e5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62352e5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62352e5b')) {
      api.createRecord('62352e5b', component.options)
    } else {
      api.reload('62352e5b', component.options)
    }
    module.hot.accept("./BookingImballi.vue?vue&type=template&id=62352e5b&scoped=true&", function () {
      api.rerender('62352e5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingImballi.vue"
export default component.exports